import React, {Fragment} from "react";
import {
    Button,
    Col,
    Collapse,
    Descriptions,
    Divider,
    Dropdown,
    List,
    Menu, notification,
    Popconfirm,
    Row,
    Space,
    Tag,
    Tooltip, Typography
} from "antd";
import PermissionHidden from "../../../../components/permissions/PermissionHidden";
import {
    AlertOutlined,
    CommentOutlined,
    CreditCardOutlined,
    DeleteOutlined, EditOutlined,
    EnvironmentOutlined, FieldTimeOutlined, FileOutlined,
    HomeOutlined,
    HourglassOutlined,
    InfoCircleOutlined,
    LinkOutlined,
    MailOutlined,
    MergeCellsOutlined, MinusCircleOutlined,
    NodeIndexOutlined,
    PhoneOutlined,
    PlusOutlined, ReloadOutlined,
    RollbackOutlined, ScheduleOutlined,
    SkinOutlined,
    TagOutlined, VerticalAlignBottomOutlined
} from "@ant-design/icons";
import RestrictedHidden from "../../../../components/permissions/RestrictedHidden";
import {checkForfait, checkPermissions} from "../../../../components/permissions/functions";
import {APP_PREFIX_PATH, ASSET_BASE_URL} from "../../../../configs/AppConfig";
import ContactIcon from "../../../../components/util-components/ContactIcon";
import moment from "moment";
import IntlMessage from "../../../../components/util-components/IntlMessage";
import ApiService from "../../../../services/ApiService";

const {Text, Title} = Typography

export class FicheFamilleLink extends React.Component {

    async onDeleteFamilyLink(contact, type, notif = true) {
        if (!checkPermissions(["contact.edit"]) || !checkForfait(["CRM", "COM", "FULL"])) {
            notification.error({
                message: <IntlMessage id="access.error"/>
            })
            return false
        }

        const selected = this.props.selected

        await ApiService.post("/contact/familylink/delete/" + contact + "/" + type + "/" + selected.id)
        await this.props.fiche.getData()

        if (notif) {
            notification.success({
                message: <IntlMessage id="success.delete"/>
            })
        }
    }





    render() {
        const {selected, fiche} = this.props

        if (!selected) {
            return null
        }

        if (selected.familyLinks.length === 0) {
            return null
        }

        return (
            <Col>
                <Col style={{display: "flex", justifyContent: "flex-end", marginBottom: 30}}>
                    <Button type="primary" icon={<PlusOutlined/>}
                            onClick={() => fiche.modalAddFamilyLink.show(selected.id, selected.nom + " " + selected.prenom)}>Ajouter
                        un lien familial</Button>
                </Col>
                {selected.familyLinks.map((item, index) => {
                    var contact = selected.familyContacts.find(i => i.id === item.contact)
                    if (!contact) {
                        this.onDeleteFamilyLink(item.contact, item.type, false)
                        contact = {
                            nom: item.contact
                        }
                        //return null
                    }
                    return (
                        <Fragment key={index}>
                            <Space size="small">
                                <Popconfirm
                                    title="Êtes-vous sûrs de vouloir retirer cette relation du contact ?"
                                    onConfirm={() => this.onDeleteFamilyLink(item.contact, item.type)}
                                    okText="Oui"
                                    cancelText="Non"
                                    okType={"danger"}
                                >
                                    <Button danger type={"text"} icon={<MinusCircleOutlined/>}/>
                                </Popconfirm>

                                {fiche.formatFamilyLink(item.type, selected.homme)}

                                <Button icon={<ContactIcon contact={contact}/>}
                                        type="link"
                                        onClick={() => fiche.modalContact.show(item.contact)}>{contact.nom} {contact.prenom}</Button>
                            </Space>
                            {selected.familyLinks.length > 1 && index < selected.familyLinks.length - 1 && (
                                <Divider/>
                            )}
                        </Fragment>

                    )
                })
                }
            </Col>
        )
    }
}
